<div class="space-y-5">
  <!-- Header -->
  <div class="flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 class="text-vivid-royal-500 dark:text-dark-khaki-50 text-lg md:text-xl">Horarios de Carga</h1>
      @if(groupName) {
        <p class="text-xs text-vivid-royal-400 mt-1">
          <i class="pi pi-folder mr-1"></i> Grupo: <span class="font-semibold text-vivid-royal-600 dark:text-vivid-royal-200">{{ groupName }}</span>
        </p>
      }
    </div>
    <div class="flex items-center gap-3">
      <label class="text-sm text-vivid-royal-500 dark:text-vivid-royal-200 font-medium">Sin restricción</label>
      <p-toggleswitch [(ngModel)]="enabledSchedule" />
    </div>
  </div>

  @if(enabledSchedule) {
    <div class="text-sm text-vivid-royal-400 bg-vivid-royal-50 dark:bg-vivid-royal-900 rounded-lg px-3 py-2">
      <i class="pi pi-info-circle mr-1"></i> Sin restricción — el dispositivo puede cargar a cualquier hora. Desactive el toggle para configurar horarios.
    </div>
  }

  <!-- Schedule Grid — always visible -->
  <div class="overflow-x-auto rounded-lg border border-dark-khaki-200 dark:border-vivid-royal-700" [ngClass]="{'opacity-40 pointer-events-none': enabledSchedule}">
    <table class="w-full text-xs select-none">
      <thead>
        <tr class="bg-dark-khaki-50 dark:bg-vivid-royal-900">
          <th class="text-left py-2 px-3 font-semibold text-vivid-royal-600 dark:text-vivid-royal-200 w-24">Día</th>
          @for(h of hours; track h) {
            <th class="py-2 px-0 text-center cursor-pointer hover:text-mustard-600 text-vivid-royal-400 font-medium"
              (click)="toggleHourColumn(h)" pTooltip="Toggle hora {{ h }}">
              {{ h.toString().padStart(2, '0') }}
            </th>
          }
          <th class="w-10"></th>
        </tr>
      </thead>
      <tbody>
        @for(day of days; track day.key) {
          <tr class="border-t border-dark-khaki-100 dark:border-vivid-royal-800" (mouseleave)="stopDraw()">
            <td class="py-1.5 px-3">
              <button type="button" class="text-sm font-semibold w-full text-left transition-colors"
                [ngClass]="day.checked ? 'text-mustard-600 dark:text-mustard-400' : 'text-vivid-royal-700 dark:text-vivid-royal-200'"
                (click)="toggleDay(day)">
                {{ day.label }}
              </button>
            </td>
            @for(cell of day.hours; track cell.hour) {
              <td class="px-0 py-1.5 text-center">
                <div class="w-5 h-5 mx-auto rounded-sm cursor-pointer transition-colors duration-100 flex items-center justify-center text-[10px]"
                  [ngClass]="cell.active
                    ? 'bg-green-500 text-white'
                    : 'bg-red-100 text-red-400 dark:bg-red-900 dark:text-red-300'"
                  (mousedown)="changeState(cell)"
                  (mouseenter)="drawCell(cell)"
                  (mouseup)="stopDraw()">
                  {{ cell.active ? '✓' : '✕' }}
                </div>
              </td>
            }
            <td class="text-center">
              <button pButton type="button" icon="pi pi-replay" class="p-button-text p-button-sm p-button-rounded"
                pTooltip="Toggle todo el día" (click)="toggleDay(day)"></button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <!-- Legend -->
  <div class="flex gap-4 text-xs text-vivid-royal-400">
    <span class="flex items-center gap-1"><span class="w-3 h-3 rounded-sm bg-green-500 inline-block text-white text-[8px] text-center leading-3">✓</span> Permitido</span>
    <span class="flex items-center gap-1"><span class="w-3 h-3 rounded-sm bg-red-100 dark:bg-red-900 inline-block text-red-400 text-[8px] text-center leading-3">✕</span> No permitido</span>
  </div>
  <p class="text-xs text-vivid-royal-400">Click en nombre del día para seleccionar/deseleccionar todo. Click en la hora del encabezado para toggle en columna. Arrastra para pintar.</p>

  @if(showMessageError) {
    <div class="text-sm text-red-700 bg-red-100 border border-red-300 rounded-lg px-3 py-2">{{ messagesError }}</div>
  }

  @if(isAdmin) {
    <div class="flex justify-end">
      <button pButton label="Guardar" icon="pi pi-check" class="p-button-sm" type="button" (click)="saveSchedule()"></button>
    </div>
  }
</div>
